import { getLoggerBuilder } from "@nextcloud/logger";
const logger = getLoggerBuilder().detectUser().setApp("@nextcloud/vue").build();
export {
  logger as l
};
//# sourceMappingURL=logger-D3RVzcfQ.mjs.map
